import React from 'react'
import CrumbArrow from '../../widgets/CrumbArrow';
import { selectedConfigBase } from '../../../hooks/useSelector';
import { useConfigPathContext } from '../../../providers/ConfigPathContextProvider';
import { useConfigStepsContext } from '../../../providers/ConfigStepsContextProvider';
import { useBreadCrumbsContext } from '../../../providers/BreadCrumbsContextProvider';
import './PathCrumbs.css'

//------------------------------------------   STATIC   --------------------------------//

const crumbStringToArrows = (fullPath, pathBase) => {    
    if (fullPath === pathBase) {
      return '';
    }
    
    const pathAfterBase = fullPath.replace(pathBase, '');
    const prepareCrumbNames = pathAfterBase.split("']['");

    const firstPos = 0;
    if (prepareCrumbNames[firstPos]) {
      prepareCrumbNames[firstPos] = prepareCrumbNames[firstPos].replace("['", '');
    }

    const lastPos = prepareCrumbNames.length -1;
    if (prepareCrumbNames[lastPos]) {
      prepareCrumbNames[lastPos] = prepareCrumbNames[lastPos].replace("']", '');
    }

    let crumbNames = '';

    return prepareCrumbNames.map(crumbName => {
      if (crumbName) {      
        crumbNames = crumbNames + "['"+crumbName+"']";
        const bcPath = pathBase + crumbNames;
        return <CrumbArrow key={bcPath} path={bcPath}>{crumbName}</CrumbArrow>
      }
      else {
        return '';
      }
    });
}

//-------------------[  PathCrumbs  ]------------------------------------------------------//

const PathCrumbs = () => {  
  const {configPath}  = useConfigPathContext();
  const {configSteps} = useConfigStepsContext();
  const {configCrumbs} = useBreadCrumbsContext();

  const selectedBase = selectedConfigBase(configSteps);

  let compActivePath = '';
  let compLongestHistoryPath = '';

  if (configPath) {
    compActivePath = crumbStringToArrows(configPath, selectedBase); // basePath
    
    if (configCrumbs) {
      const allPaths = Object.keys(configCrumbs);
      if (allPaths) {
        let longest = '';
        allPaths.filter(cPath => cPath.startsWith(configPath)).forEach(path => {
          // console.log('SmartCheck: Path: '+path);
          if (path.length > longest.length) {
            longest = path;
          }
        })
        
        compLongestHistoryPath = crumbStringToArrows(longest, configPath);
      }
    }
  }

  // 4. Draw also the rest of the active branch.  i.e. search for other crumbs in the breadCrumbs coming after the active crumb.  
  // 5. Check the option for Tree BreadCrumbs.  i.e. we will show other branches we already traveled through.  not just the currernt branch path.
  // 5.1 One option is to "suggest" other crumb "routes" on a tooltip.  Awesome!!

  // This is good for HISTORY paths,  FAVORITES, etc..
  // TODO: Smart Favorites according to times visited.  need to keep count on each folder clicked...
  
  return (
    <div style={{display:'flex', flexDirection:'row'}}>
            <div className='pathCrumbs'>
                <CrumbArrow key='root' name='root' path={selectedBase} isFirst='true'> / </CrumbArrow>
                {compActivePath}
            </div>
            <div className='pathCrumbs Suggestions'>
              {compLongestHistoryPath}
            </div>
    </div>
  )
}

export default React.memo(PathCrumbs);